import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Event from '../views/Event.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/newyear/',
        name: 'HomeNewyear',
        component: Home
    },
    {
        path: '/newyear/:id',
        name: 'EventNewyear',
        component: Event
    },

]

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(from, to) {
        if (from.name !== to.name) {
            return {x: 0, y: 0}
        }
    }
})

export default router
